












































































































import Changepasswd from '@components/Changepasswd.vue';
import renew from '../../../components/renew.vue'
import {
    Component,
    Vue
} from 'vue-property-decorator';
@Component({
    components: {
        Changepasswd,
        renew
    }
})
export default class Usercenter extends Vue {
    private isHover: boolean = false;
    private userinfo: object = {};
    private alertdata: object = {
        title: '',
        type: '',
        user: ''
    };
    private jfidmap: object = {
        '小学-低龄': 4,
        '小学-中龄': 5,
        '小学-高龄': 1,
        '初中': 2,
        '高中': 3,
        '幼龄': 9,
    }
    private szidmap: object = {
        '小学': 6,
        '初中': 7,
        '高中': 8
    };
    private color: object = {
        '小学': {
            color: '#B5F5EC',
            img: 'xd',
        },
        '初中': {
            color: '#BAE7FF',
            img: 'cz',
        },
        '高中': {
            color: '#FFCCC7',
            img: 'gz',
        },
        '小学-低龄': {
            color: '#B5F5EC',
            img: 'xd',
        },
        '小学-中龄': {
            color: '#B5F5EC',
            img: 'xz',
            hidden:true
        },
        '小学-高龄': {
            color: '#B5F5EC',
            img: 'xg',
        },
        '幼龄': {
            color: '#B5F5EC',
            img: 'xg',
            hidden:true
        }
    };
    private viewAuthority: any = [];
    private defaultImg: string = '';
    private imgData: object = {
        accept: 'image/gif, image/jpeg, image/png, image/jpg',
    };
    private activateup() {
        (this as any).$refs.imgfile.click();
    }
    private mounted() {
        this.getdata();
        this.defaultImg = JSON.parse((localStorage as any).getItem(
            'userinfo')).headImg;
    }
    private changepasswd() {
        // (this as any).$refs.changealert.$children[0].showAlert = true;
        (this as any).$refs.changealert.showAlert = true;
    }
    private getdata() {
        const me = this;
        (me as any).request('/user/getUserInfo.json', {}).then((res:
            any) => {
            me.userinfo = res.data;
            for (let i in res.data.viewAuthority) {
                me.viewAuthority.unshift(res.data.viewAuthority[
                    i]);
            }
        })
    }
    private chooseImg(event: any): void {
        const me = this;
        me.uploadImg(event, (data: any) => {
            (me as any).userinfo.headImg = data;
            (document as any).getElementById('AI-tab-user')
                .setAttribute('src', data);
            const userinfo = JSON.parse((localStorage as any)
                .getItem('userinfo'))
            userinfo.headImg = data;
            localStorage.setItem('userinfo', JSON.stringify(
                userinfo));
        });
    }
    private uploadImg(event: any, callBack: any) {
        const me = this;
        const reader = new FileReader();
        let img1: any;
        if (event.target.files[0] && event.target.files[0] !== '') {
            img1 = event.target.files[0];
            const size = img1.size;
            let type = event.target.files[0].name.split('.').pop();
            if (!(['jpg', 'gif', 'png'].includes(type))) {
                (this as any).$alert({
                    msg: '上传格式不支持！'
                })
                return
            }
            let uri = '';
            const form: any = new FormData();
            form.append('file', img1, img1.name);
            if (img1) {
                (me as any).$axios.post('/user/upload4Img.json',
                    form, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    }).then((response: any) => {
                    uri = response.data.data.fullPath;
                    reader.readAsDataURL(img1);
                    reader.onloadend = () => {
                        if (callBack) {
                            callBack(uri);
                        }
                    };
                });
            }

        }

    }
    private openqx(type: string, xd: string, kttype: string, id: any) {
        if ((this as any).common.Checklogin(this)) {
            (this as any).alertdata = {
                title: kttype,
                id: id,
                type: type,
                main: xd
            };
            (this as any).$refs.renew.alertshow = true;
        }
    }
}
